import type { MapPlugin, PluginContext } from "./Plugin.types";

export class PluginManager {
  private plugins = new Map<string, MapPlugin>();

  register(plugin: MapPlugin, ctx: PluginContext) {
    if (this.plugins.has(plugin.id)) return;
    plugin.init?.(ctx);
    this.plugins.set(plugin.id, plugin);
  }

  unregister(id: string, ctx: PluginContext) {
    const plugin = this.plugins.get(id);
    if (!plugin) return;

    plugin.destroy?.(ctx);
    this.plugins.delete(id);
  }

  clear(ctx: PluginContext) {
    this.plugins.forEach((p) => p.destroy?.(ctx));
    this.plugins.clear();
  }
}
